var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoMakerHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.879,
    height: 26.879,
    viewBox: "0 0 26.879 26.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2235",
    "data-name": "Raggruppa 2235",
    transform: "translate(-16489.508 20980.691)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_2140",
    "data-name": "Raggruppa 2140",
    transform: "translate(16458.48 -21409.627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1263",
    "data-name": "Tracciato 1263",
    d: "M19.349,12.392,10.4,7.917A1.659,1.659,0,0,0,8,9.4v8.454a1.659,1.659,0,0,0,2.4,1.483l8.949-4.474A1.382,1.382,0,0,0,19.349,12.392Z",
    transform: "translate(30.938 428.746)",
    fill: "none",
    stroke: "#55d144",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellisse_15",
    "data-name": "Ellisse 15",
    cx: 12.439,
    cy: 12.439,
    rx: 12.439,
    ry: 12.439,
    transform: "translate(32.027 429.936)",
    fill: "none",
    stroke: "#55d144",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoMakerHome);
export default __webpack_public_path__ + "static/media/video-maker-home.9b2a5334ab2d75eb0cc80a4b9818a1ad.svg";
export { ForwardRef as ReactComponent };